module.exports = __webpack_public_path__ + "img/heart-pulse-gray.17030630.svg";